import { api } from "./client";

export interface OnboardingSummary {
  application_id: number;
  legal_business_name: string;
  contact_name: string;
  contact_email: string;
  traffic_type: string;
  status: string;
  created_at: string | null;
}

export interface OnboardingDetail extends OnboardingSummary {
  dba_name: string | null;
  entity_type: string;
  tax_id_ein: string | null;
  incorporation_region: string | null;
  website: string | null;
  address_line1: string;
  address_line2: string | null;
  city: string;
  state_region: string;
  postal_code: string;
  country: string;
  contact_title: string;
  contact_phone: string;
  use_case: string;
  expected_daily_volume: string | null;
  calling_regions: string | null;
  consent_method: string;
  attest_consent: boolean;
  attest_dnc: boolean;
  attest_accurate: boolean;
  agree_terms: boolean;
  reviewer_note: string | null;
}

export async function listOnboarding(statusFilter?: string): Promise<OnboardingSummary[]> {
  const resp = await api.get<{ data: OnboardingSummary[] }>("/onboarding/", {
    params: statusFilter ? { status_filter: statusFilter } : {},
  });
  return resp.data.data;
}

export async function getOnboarding(id: number): Promise<OnboardingDetail> {
  const resp = await api.get<{ data: OnboardingDetail }>(`/onboarding/${id}`);
  return resp.data.data;
}

export async function reviewOnboarding(id: number, status: string, note?: string): Promise<void> {
  await api.put(`/onboarding/${id}/review`, { status, reviewer_note: note || null });
}

// ---- Public help assistant (the bubble on /apply) ----

export interface AssistTurn {
  role: "user" | "assistant";
  content: string;
}

export async function assistAvailable(): Promise<boolean> {
  try {
    const r = await api.get<{ data: { enabled: boolean } }>("/onboarding/assist/status");
    return Boolean(r.data.data?.enabled);
  } catch {
    return false; // a status probe must never break the form
  }
}

export async function askApplicationHelper(question: string, history: AssistTurn[]): Promise<string> {
  const r = await api.post<{ data: { answer: string } }>("/onboarding/assist", {
    question,
    history: history.slice(-8),
  });
  return r.data.data.answer;
}

export function assistErrorMessage(err: unknown): string {
  const e = err as { response?: { status?: number; data?: { detail?: string } } };
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (e?.response?.status === 429) return "You've asked a lot of questions — please try again later.";
  return "Sorry, I couldn't answer that just now. Please try again, or email sales@reliadata.io.";
}
